import { useState } from "react";
import { Container, Tabs, Title } from "@mantine/core";
import {
  IconCalendarTime,
  IconCash,
  IconChartBar,
  IconUsers,
} from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

import { useCurrentUser } from "../hooks/useCurrentUser";
import { WorkersTab } from "../components/workers/WorkersTab";
import { AttendanceTab } from "../components/workers/AttendanceTab";
import { PaymentsTab } from "../components/workers/PaymentsTab";
import { ReportTab } from "../components/workers/ReportTab";

export function Workers() {
  const { t } = useTranslation();
  const user = useCurrentUser();
  const isAdmin = user.role === "admin";
  const [tab, setTab] = useState<string>("workers");

  return (
    <Container size="lg">
      <Title order={3} mb="md">
        {t("workers.title")}
      </Title>
      <Tabs value={tab} onChange={(v) => setTab(v ?? "workers")}>
        <Tabs.List>
          <Tabs.Tab value="workers" leftSection={<IconUsers size={14} />}>
            {t("workers.tabs.workers")}
          </Tabs.Tab>
          <Tabs.Tab value="attendance" leftSection={<IconCalendarTime size={14} />}>
            {t("workers.tabs.attendance")}
          </Tabs.Tab>
          {isAdmin && (
            <Tabs.Tab value="payments" leftSection={<IconCash size={14} />}>
              {t("workers.tabs.payments")}
            </Tabs.Tab>
          )}
          {isAdmin && (
            <Tabs.Tab value="reports" leftSection={<IconChartBar size={14} />}>
              {t("workers.tabs.reports")}
            </Tabs.Tab>
          )}
        </Tabs.List>

        <Tabs.Panel value="workers" pt="md">
          <WorkersTab isAdmin={isAdmin} />
        </Tabs.Panel>
        <Tabs.Panel value="attendance" pt="md">
          <AttendanceTab isAdmin={isAdmin} />
        </Tabs.Panel>
        {isAdmin && (
          <Tabs.Panel value="payments" pt="md">
            <PaymentsTab />
          </Tabs.Panel>
        )}
        {isAdmin && (
          <Tabs.Panel value="reports" pt="md">
            <ReportTab />
          </Tabs.Panel>
        )}
      </Tabs>
    </Container>
  );
}
